import { render, staticRenderFns } from "./ConstraintText.vue?vue&type=template&id=31f13ee8&"
import script from "./ConstraintText.vue?vue&type=script&lang=ts&"
export * from "./ConstraintText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports